import Vue from 'vue'
import Router from 'vue-router'
import indexPage from '@/views/index/index'
import searchResult from '@/views/index/searchResult'
import specialistCenter from '@/views/specialistCenter/index'
import aboutUs from '@/views/aboutUs/index'
import cases from '@/views/case/index'
import caseDetail from '@/views/case/caseDetail'
import cloudClassroom from '@/views/cloudClassroom'
import enterprise from '@/views/enterprise'
import enterpriseDetail from '@/views/enterprise/enterpriseDetail'
import savant from '@/views/savant/index'
import detail from '@/views/savant/detail'
import statistics from '@/views/statistics/index'
import common from '@/views/common/index'
Vue.use(Router)

export default new Router({
    mode:'history',
    routes: [{
        path: '/',
        name: 'index',
        // component: () => import('@/views/index/index'),
        component: indexPage,
        meta:{
            keepAlive:true
        }
    },
    {
        path: '/index/searchResult',
        name: 'searchResult',
        // component: () => import('@/views/index/index'),
        component: searchResult,
        meta:{
            keepAlive:true
        }
    },{
        path: '/specialistCenter',
        name: 'specialistCenter',
        // component: () => import('@/views/index/index'),
        component: specialistCenter
    },{
        path: '/aboutUs',
        name: 'aboutUs',
        // component: () => import('@/views/index/index'),
        component: aboutUs,
        
    },
    {
        path: '/case',
        name: 'case',
        // component: () => import('@/views/index/index'),
        component: cases,
        meta:{
            keepAlive:true
        }
    },
    {
        path: '/cloudClassroom',
        name: 'cloudClassroom',
        // component: () => import('@/views/cloudClassroom/index'),
        component: cloudClassroom
    },
    {
        path: '/common',
        name: 'common',
        // component: () => import('@/views/cloudClassroom/index'),
        component: common
    },
    {
        path: '/case/caseDetail',
        name: 'caseDetail',
        // component: () => import('@/views/index/index'),
        component: caseDetail
    },
    {
        path: '/enterprise',
        name: 'enterprise',
        // component: () => import('@/views/index/index'),
        component: enterprise,
        meta:{
            keepAlive:true
        }
    },
    {
        path: '/enterprise/enterpriseDetail',
        name: 'enterpriseDetail',
        // component: () => import('@/views/index/index'),
        component: enterpriseDetail,
        meta:{
            keepAlive:true
        }
    },
    {
        path: '/savant',
        name: 'savant',
        // component: () => import('@/views/index/index'),
        component: savant,
        meta:{
            keepAlive:true
        }
    },{
        path: '/savant/detail',
        name: 'detail',
        // component: () => import('@/views/index/index'),
        component: detail
    },
    {
        path: '/statistics',
        name: 'statistics',
        // component: () => import('@/views/index/index'),
        component: statistics
    },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js